import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import {withRouter} from "../../lib/react/withRouter";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pos_Prds extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];

    this.state.mna = [];
    this.state.mna.push({ mnid: "mn01", pos: "c1", text: "STRUKTURER", desc: "Produkt gruppering/trädstruktur", link: "/pos/prds/str" });
    this.state.mna.push({ mnid: "mn02", pos: "c1", text: "PRODUKTER", desc: "Produktregister", link: "/pos/prds/plus" });
    this.state.mna.push({ mnid: "mn03", pos: "c1", text: "MENYER", desc: "Menyregister", link: "/pos/prds/menus" });
    this.state.mna.push({ mnid: "mn04", pos: "c1", text: "INGREDIENSER", desc: "Ingrediens register", link: "/pos/prds/ingred" });
    this.state.mna.push({ mnid: "mn05", pos: "c1", text: "KNAPPAR", desc: "Knappgruppering och koppling", link: "/pos/prds/btns" });
    this.state.mna.push({ mnid: "mn06", pos: "c2", text: "TILLVAL", desc: "Tillval till produkter", link: "/pos/prds/addons" });
    this.state.mna.push({ mnid: "mn07", pos: "c2", text: "VILLKOR", desc: "Villkorsstyrd försäljning", link: "/pos/prds/cond" });
    this.state.mna.push({ mnid: "mn08", pos: "c2", text: "STEGVAL", desc: "Stegval/Menykopplade produkter", link: "/pos/prds/steps" });
    this.state.mna.push({ mnid: "mn09", pos: "c2", text: "HAPPY HOUR", desc: "Happy Hour definitioner", link: "/pos/prds/happy" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
  fknGo(url) {
    //alert(row.href);
      this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Produkter</h3>
            <p>Produktfunktioner funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    </div>
  );
    }
}
export default withRouter(Pos_Prds);
